export default __webpack_public_path__ + "static/media/logo_mbrf2.90a309ca.png";